module.exports = __webpack_public_path__ + "static/media/dcc2412-60a.6e49a645.jpg";